import getAxios from "./axiosService";
import userService from "./userService";

const _commInfoKey = "kkComicInfo";
let commService = {
  getInitData() {
    let branchId = userService.getBranchId();
    let url = '/api/common/info/v2/' + branchId;
    return new Promise((resolve, reject) => {
      let axios = getAxios(true);
      axios.get(url)
        .then(res => {
          if (res.status === 200) {
            window.localStorage.setItem(_commInfoKey, JSON.stringify(res.data.data));
            resolve(res.data);
          } else {
            console.error(`get common info error`, res);
            reject();
          }
        })
    })
  },
  getLocalInitData() {
    return JSON.parse(window.localStorage.getItem(_commInfoKey));
  }
}

export default commService;



// WEBPACK FOOTER //
// ./src/services/commService.js